export default {"src":"/_next/static/media/AppStore.b67657ec.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};